﻿import { useEffect, useRef } from "react";

type DeleteCodeConfirmModalProps = {
  open: boolean;
  title?: string;
  message: string;
  code: string;
  input: string[];
  error?: string;
  isPending?: boolean;
  onClose: () => void;
  onInputChange: (next: string[]) => void;
  onErrorReset?: () => void;
  onConfirm: () => void;
  confirmLabel?: string;
  pendingLabel?: string;
};

export const DeleteCodeConfirmModal = ({
  open,
  title = "Löschen bestätigen",
  message,
  code,
  input,
  error,
  isPending,
  onClose,
  onInputChange,
  onErrorReset,
  onConfirm,
  confirmLabel = "Löschen bestätigen",
  pendingLabel = "Lösche..."
}: DeleteCodeConfirmModalProps) => {
  const codeInputRefs = useRef<Array<HTMLInputElement | null>>([]);

  useEffect(() => {
    if (!open) return;
    const timer = setTimeout(() => codeInputRefs.current[0]?.focus(), 0);
    return () => clearTimeout(timer);
  }, [open]);

  if (!open) return null;

  return (
    <div className="modal-backdrop">
      <section className="panel modal-card">
        <h3 style={{ marginTop: 0, marginBottom: 8 }}>{title}</h3>
        <p style={{ marginTop: 0 }}>{message}</p>
        <p style={{ marginTop: 0 }}>
          Bitte gib zur Bestätigung die folgende 4-stellige Sicherheitszahl ein:
          <strong style={{ marginLeft: 8 }}>{code}</strong>
        </p>
        <div className="form-field">
          <label>Sicherheitszahl</label>
          <div className="security-code-grid">
            {input.map((digit, index) => (
              <input
                key={index}
                className="security-code-input"
                inputMode="numeric"
                maxLength={1}
                value={digit}
                onChange={(e) => {
                  const nextDigit = e.target.value.replace(/\D/g, "").slice(-1);
                  const nextInput = [...input];
                  nextInput[index] = nextDigit;
                  onInputChange(nextInput);
                  onErrorReset?.();
                  if (nextDigit && index < 3) codeInputRefs.current[index + 1]?.focus();
                }}
                onKeyDown={(e) => {
                  if (e.key === "Backspace" && !input[index] && index > 0) {
                    codeInputRefs.current[index - 1]?.focus();
                  }
                }}
                ref={(el) => {
                  codeInputRefs.current[index] = el;
                }}
              />
            ))}
          </div>
        </div>
        {error ? <div className="error-text">{error}</div> : null}
        <div className="form-actions">
          <button onClick={onClose} disabled={isPending}>
            Abbrechen
          </button>
          <button onClick={onConfirm} disabled={isPending}>
            {isPending ? pendingLabel : confirmLabel}
          </button>
        </div>
      </section>
    </div>
  );
};
